import React, { useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change } from 'redux-form';

import classNames from 'clsx';
import Check from 'mdi-material-ui/Check';
import ExclamationThick from 'mdi-material-ui/ExclamationThick';
import { MubiInstallmentsContext } from 'app/components/MubiInstallmentsRadioOption/useMubiInstallments.context';
import { selectIsFormMicroCenterActive } from 'app/store/selectors/selectIsFormMicroCenterActive';

import { InstallmentsEnum, FormsEnum } from 'app/shared/enums';
import { NewButton } from 'app/components/NewButton';

import { ResultsProps } from './Results.interfaces';
import { useStyles } from './Results.styles';

const Results = ({ installmentsAvailable }: ResultsProps) => {
  const classes = useStyles();
  const {
    setHiProInstalmentContractConfirmed,
    setIsRejected,
    mubiInstallmentsDataLayerEvent,
    closeModal,
  } = useContext(MubiInstallmentsContext);
  const dispatch = useDispatch();
  const isFormMicroCenterActive = useSelector(selectIsFormMicroCenterActive);

  useEffect(() => {
    if (installmentsAvailable) {
      mubiInstallmentsDataLayerEvent(
        InstallmentsEnum.EventModalStep,
        InstallmentsEnum.EventStepNameSuccessfulFinish
      );
    } else {
      mubiInstallmentsDataLayerEvent(
        InstallmentsEnum.EventModalStep,
        InstallmentsEnum.EventStepNameRefusal
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleActionButtonClick = () => {
    if (installmentsAvailable) {
      setHiProInstalmentContractConfirmed(installmentsAvailable);
    } else {
      mubiInstallmentsDataLayerEvent(
        InstallmentsEnum.EventNameRefusalReturn,
        InstallmentsEnum.EventStepNameRefusal
      );
      setIsRejected(true);
      dispatch(change(FormsEnum.CheckoutPaymentForm, 'payment', {}));
    }
    closeModal();
  };

  return (
    <>
      <div className={classes.modalContent}>
        {installmentsAvailable ? (
          <Check className={classNames(classes.icon, classes.successIcon)} />
        ) : (
          <ExclamationThick
            className={classNames(classes.icon, classes.warningIcon)}
          />
        )}
        <div className={classes.heading}>
          {installmentsAvailable ? (
            <h2>
              <span>{`${InstallmentsEnum.Congratulations}\n`}</span>
              {InstallmentsEnum.AgreementSigned}
            </h2>
          ) : (
            <h4>{InstallmentsEnum.DecisionNegative}</h4>
          )}
        </div>
        <p className={classes.description}>
          {installmentsAvailable ? (
            <>
              {InstallmentsEnum.AgreementSignedDescription1}
              <br />
              <strong>{InstallmentsEnum.AgreementSignedDescription2}</strong>
            </>
          ) : (
            InstallmentsEnum.DecisionNegativeDescription
          )}
        </p>
      </div>
      <NewButton
        className={classes.submitButton}
        fullWidth
        title={
          installmentsAvailable
            ? InstallmentsEnum.CompletePolicyPurchase
            : InstallmentsEnum.BackToPaymentOptions
        }
        variant="contained"
        color="primary"
        onClick={handleActionButtonClick}
        data-cy="results-process-mubi-installments"
        rounded={isFormMicroCenterActive}
      />
    </>
  );
};

export default Results;
